import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Formik, Form, Field } from 'formik';

import Loading from 'components/Loading';

export default function ChangeNameForm({
  cost,
  onSubmit,
}) {
  return (
    <Formik
      initialValues={{
        name: '',
      }}
      onSubmit={onSubmit}
      render={({ values, isSubmitting }) => (
        <Form>
          <p>
            {`This will cost ${cost} Fate.`}
          </p>
          <Field
            type="text"
            className="form__control"
            style={{ marginBottom: '1rem' }}
            value={values.name}
            name="name"
            required
          />
          <div className="buttons">
            <button
              type="submit"
              disabled={isSubmitting}
              className={classnames(
                'button button--primary',
                isSubmitting && 'button--disabled',
              )}
            >
              {isSubmitting ? <Loading spinner small /> : 'Change'}
            </button>
          </div>
        </Form>
      )}
    />
  );
}

ChangeNameForm.propTypes = {
  cost: PropTypes.number.isRequired,
  onSubmit: PropTypes.func.isRequired,
};